// import React from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Toolbar,
// } from '@mui/material';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import SettingsIcon from '@mui/icons-material/Settings';
// import AccountCircleIcon from '@mui/icons-material/AccountCircle';
// import { useNavigate } from 'react-router-dom';

// const drawerWidth = 240;

// const Sidebar = () => {
//   const navigate = useNavigate();

//   const menuItems = [
//     { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
//     { text: 'Profile', icon: <AccountCircleIcon />, path: '/profile' },
//     { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
//   ];

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         [`& .MuiDrawer-paper`]: {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//           backgroundColor: '#1e88e5',
//           color: '#fff',
//         },
//       }}
//     >
//       <Toolbar />
//       <List>
//         {menuItems.map((item) => (
//           <ListItem key={item.text} disablePadding>
//             <ListItemButton onClick={() => navigate(item.path)}>
//               <ListItemIcon sx={{ color: '#fff' }}>{item.icon}</ListItemIcon>
//               <ListItemText primary={item.text} />
//             </ListItemButton>
//           </ListItem>
//         ))}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;

// import React from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Box,
// } from '@mui/material';
// import {
//   Dashboard as DashboardIcon,
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';

// const drawerWidth = 240;

// const Sidebar = () => {
//   const navigate = useNavigate();

//   const menuItems = [
//     { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
//     { text: 'Products', icon: <InventoryIcon />, path: '/products' },
//     { text: 'Customers', icon: <PeopleIcon />, path: '/customers' },
//     { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
//   ];

//   return (
//     <Drawer
//       variant="permanent"
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//         },
//       }}
//     >
//       <Box sx={{ p: 3 }}>
//         <Typography variant="h6" fontWeight="bold">
//           BMS
//         </Typography>
//       </Box>
//       <List>
//         {menuItems.map((item) => (
//           <ListItem
//             button
//             key={item.text}
//             onClick={() => navigate(item.path)}
//           >
//             <ListItemIcon>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItem>
//         ))}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;

// import React , { useMemo } from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Box,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import {
//   Dashboard as DashboardIcon,
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
//   Receipt as ReceiptIcon,
//   AttachMoney as PaymentIcon,
//   Assignment as TaskIcon,
//   Store as StoreIcon,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';

// // const drawerWidth = 240;

// const Sidebar = ({ isOpen, toggleSidebar }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();

//   const drawerWidth = useMemo(() => {
//     if (isMobile) return 0;
//     if (isTablet) return 180;
//     return 200;
//   }, [isMobile, isTablet]);

//   const menuItems = [
//     { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
//     { text: 'Products', icon: <InventoryIcon />, path: '/products' },
//     { text: 'Customers', icon: <PeopleIcon />, path: '/customers' },
//     { text: 'Bills', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Payments', icon: <PaymentIcon />, path: '/payments' },
//     { text: 'Tasks', icon: <TaskIcon />, path: '/tasks' },
//     { text: 'Inventory', icon: <StoreIcon />, path: '/inventory' },
//     { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
//   ];

//   const drawer = (
//     <>
//       <Box sx={{ p: 3, mt: 8 }}>
//         <Typography variant="h6" fontWeight="bold">
//           BMS
//         </Typography>
//       </Box>
//       <List>
//         {menuItems.map((item) => (
//           <ListItem
//             button
//             key={item.text}
//             onClick={() => {
//               navigate(item.path);
//               if (isMobile) toggleSidebar();
//             }}
//           >
//             <ListItemIcon>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItem>
//         ))}
//       </List>
//     </>
//   );

//   return (
//     <Drawer
//       variant={isMobile ? 'temporary' : 'persistent'}
//       anchor="left"
//       open={isOpen}
//       onClose={toggleSidebar}
//       ModalProps={{
//         keepMounted: true, // Better mobile performance
//       }}
//     //   sx={{
//     //     // width: drawerWidth,
//     //     // flexShrink: 0,
//     //     // '& .MuiDrawer-paper': {
//     //     //   width: drawerWidth,
//     //     //   boxSizing: 'border-box',
//     //     width: currentWidth,
//     //     flexShrink: 0,
//     //     '& .MuiDrawer-paper': {
//     //       width: currentWidth,
//     //       boxSizing: 'border-box',
//     //       overflowX: 'hidden'
//     //     },
//     //   }}
//         sx={{
//             display: { xs: 'block', sm: 'block' },
//             '& .MuiDrawer-paper': {
//             boxSizing: 'border-box',
//             marginTop: theme.mixins.toolbar.minHeight, // Start below navbar
//             width: isMobile ? '240px' : drawerWidth, // Wider on mobile for better touch targets
//             },
//         }}
//     >
//         <List>
//         {menuItems.map((item) => (
//           <ListItem 
//             button 
//             key={item.text}
//             onClick={() => {
//               if (isMobile) toggleSidebar(); // Close sidebar on mobile after click
//               navigate(item.path);
//             }}
//           >
//             <ListItemIcon>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItem>
//         ))}
//       </List>
//       {drawer}
//     </Drawer>
//   );
// };

// export default Sidebar;

// import React, { useMemo } from 'react';
// import {
//   Drawer,
//   List,
//   ListItem,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Box,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';
// import {
//   Dashboard as DashboardIcon,
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
//   Receipt as ReceiptIcon,
//   AttachMoney as PaymentIcon,
//   Assignment as TaskIcon,
//   Store as StoreIcon,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';

// const Sidebar = ({ isOpen, toggleSidebar }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();

//   const drawerWidth = useMemo(() => {
//     if (isMobile) return 240;
//     if (isTablet) return 180;
//     return 200;
//   }, [isMobile, isTablet]);

//   const menuItems = [
//     { text: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
//     { text: 'Products', icon: <InventoryIcon />, path: '/products' },
//     { text: 'Customers', icon: <PeopleIcon />, path: '/customers' },
//     { text: 'Bills', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Payments', icon: <PaymentIcon />, path: '/payments' },
//     { text: 'Tasks', icon: <TaskIcon />, path: '/tasks' },
//     { text: 'Inventory', icon: <StoreIcon />, path: '/inventory' },
//     { text: 'Settings', icon: <SettingsIcon />, path: '/settings' },
//   ];

//   const drawer = (
//     <>
//       <Box sx={{ p: 3, mt: 2 }}>
//         <Typography variant="h6" fontWeight="bold">
//           BMS
//         </Typography>
//       </Box>
//       <List>
//         {menuItems.map((item) => (
//           <ListItem
//             button
//             key={item.text}
//             onClick={() => {
//               navigate(item.path);
//               if (isMobile) toggleSidebar();
//             }}
//           >
//             <ListItemIcon>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItem>
//         ))}
//       </List>
//     </>
//   );

//   return (
//     <Drawer
//       variant={isMobile ? 'temporary' : 'persistent'}
//       anchor="left"
//       open={isOpen}
//       onClose={toggleSidebar}
//       ModalProps={{ keepMounted: true }}
//       sx={{
//         '& .MuiDrawer-paper': {
//           boxSizing: 'border-box',
//           width: drawerWidth,
//           // backgroundColor: '#f9f9f9',
//           // color: '#000',
//           backgroundColor: 'rgba(255, 255, 255, 0.1)', // semi-transparent
//           backdropFilter: 'blur(8px)', // frosted glass effect
//           color: '#000',
//           boxShadow: 'none',
//         },
//       }}
//     >
//       {drawer}
//     </Drawer>
//   );
// };

// export default Sidebar;

// import React, { useMemo } from 'react';
// import {
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Typography,
//   Box,
//   useTheme,
//   useMediaQuery,
//   Divider,
// } from '@mui/material';
// import {
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Settings as SettingsIcon,
//   Receipt as ReceiptIcon,
//   AttachMoney as PaymentIcon,
//   Assignment as TaskIcon,
//   Store as StoreIcon,
//   Home as HomeIcon,
// } from '@mui/icons-material';
// import { useNavigate } from 'react-router-dom';

// const Sidebar = ({ isOpen = true, toggleSidebar = () => {} }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const isTablet = useMediaQuery(theme.breakpoints.down('md'));
//   const navigate = useNavigate();

//   const drawerWidth = useMemo(() => {
//     if (isMobile) return 240;
//     if (isTablet) return 180;
//     return 220;
//   }, [isMobile, isTablet]);

//   const menuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Staff', icon: <PeopleIcon />, path: '/staff' },
//     { text: 'Expenses', icon: <PaymentIcon />, path: '/expenses' },
//     { text: 'Payments', icon: <PaymentIcon />, path: '/payments' },
//     { text: 'Tasks', icon: <TaskIcon />, path: '/tasks' },
//     { text: 'Import Data', icon: <StoreIcon />, path: '/import' },
//     { text: 'Export Data', icon: <SettingsIcon />, path: '/export' },
//   ];

//   const content = (
//     <Box sx={{ width: drawerWidth, p: 2, pt: 3 }}>
//       <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
//         <Box
//           sx={{
//             width: 46,
//             height: 46,
//             borderRadius: '50%',
//             bgcolor: 'rgba(255,255,255,0.06)',
//             display: 'flex',
//             alignItems: 'center',
//             justifyContent: 'center',
//             border: '1px solid rgba(255,255,255,0.06)',
//             boxShadow: 'inset 0 1px 0 rgba(0,0,0,0.2)',
//           }}
//         >
//           <Typography fontWeight={700}>G</Typography>
//         </Box>
//         <Typography variant="h6" sx={{ fontWeight: 700 }}>
//           Ginni
//         </Typography>
//       </Box>

//       <Divider sx={{ borderColor: 'rgba(255,255,255,0.06)', mb: 1 }} />

//       <List>
//         {menuItems.map((item) => (
//           <ListItemButton
//             key={item.text}
//             onClick={() => {
//               navigate(item.path);
//               if (isMobile) toggleSidebar();
//             }}
//             sx={{
//               mb: 0.5,
//               borderRadius: 1,
//               color: 'text.primary',
//               background: 'linear-gradient(180deg, rgba(255,255,255,0.02), rgba(0,0,0,0.12))',
//             }}
//           >
//             <ListItemIcon sx={{ color: 'inherit' }}>{item.icon}</ListItemIcon>
//             <ListItemText primary={item.text} />
//           </ListItemButton>
//         ))}
//       </List>
//     </Box>
//   );

//   return (
//     <Drawer
//       variant={isMobile ? 'temporary' : 'persistent'}
//       open={isOpen}
//       onClose={toggleSidebar}
//       ModalProps={{ keepMounted: true }}
//       sx={{
//         '& .MuiDrawer-paper': {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//           backgroundColor: 'rgba(0,0,0,0.35)',
//           color: '#fff',
//           backdropFilter: 'blur(6px)',
//           borderRight: '1px solid rgba(255,255,255,0.04)',
//         },
//       }}
//     >
//       {/* keep content start below AppBar */}
//       <Box sx={{ height: (theme) => theme.mixins.toolbar.minHeight }} />
//       {content}
//     </Drawer>
//   );
// };

// export default Sidebar;




























// import React, { useState, useEffect } from 'react';
// import {
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   Box,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';

// import {
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Receipt as ReceiptIcon,
//   AttachMoney as PaymentIcon,
//   Assignment as TaskIcon,
//   Home as HomeIcon,
//   Store as StoreIcon,
//   CloudUpload as CloudUploadIcon,
//   Settings as SettingsIcon,
//   Straighten as MeasurementIcon,
//   LocalShipping as SupplierIcon,
// } from '@mui/icons-material';

// import { useNavigate } from 'react-router-dom';
// import API_BASE_URL from '../../config/api';

// const Sidebar = ({
//   isOpen = true,
//   toggleSidebar = () => {},
//   drawerWidth = 240,
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();

//   const activePath = window.location.pathname;

//   // Gold palette
//   const GOLD = "#C49A63";        
//   const GOLD_DARK = "#BF975F";   
//   const GOLD_BORDER = "#D9B67E"; 

//   const userRole = localStorage.getItem("role");
//   const [staffType, setStaffType] = useState(null);

//   // Fetch staff type if user is staff
//   useEffect(() => {
//     const fetchStaffType = async () => {
//       if (userRole === "Staff") {
//         try {
//           const token = localStorage.getItem("token");
//           const response = await fetch(`${API_BASE_URL}/api/staff/my-salary-with-type`, {
//             headers: { Authorization: `Bearer ${token}` },
//           });
          
//           if (response.ok) {
//             const data = await response.json();
//             setStaffType(data.staffType);
//           }
//         } catch (error) {
//           console.error("Error fetching staff type:", error);
//         }
//       }
//     };

//     fetchStaffType();
//   }, [userRole]);

//   // Admin menu items
//   const adminMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Staff', icon: <PeopleIcon />, path: '/staff' },
//     { text: 'Boutique Schedule', icon: <TaskIcon />, path: '/boutique-schedule' },
//     { text: 'Tasks', icon: <TaskIcon />, path: '/admin/tasks' },
//     { text: 'Customers', icon: <PeopleIcon />, path: '/admin/customers' },
//     { text: 'Suppliers', icon: <SupplierIcon />, path: '/admin/suppliers' },
//     { text: 'Other Expenses', icon: <PaymentIcon />, path: '/expenses' },
//     { text: 'Import Data', icon: <CloudUploadIcon />, path: '/admin/import' },
//     { text: 'Export Data', icon: <SettingsIcon />, path: '/admin/export' },
//   ];

//   // Hourly Staff menu items
//   const hourlyStaffMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Attendance & Salary', icon: <PaymentIcon />, path: '/my-attendance-salary' },
//   ];

//   // Task-Based Staff menu items
//   const taskBasedStaffMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Salary', icon: <PaymentIcon />, path: '/my-salary' },
//     { text: 'My Tasks', icon: <TaskIcon />, path: '/my-tasks' },
//   ];

//   // Determine which menu to show
//   let menuItems = adminMenuItems;
//   if (userRole === "Staff") {
//     if (staffType === "Hourly") {
//       menuItems = hourlyStaffMenuItems;
//     } else if (staffType === "Task-Based") {
//       menuItems = taskBasedStaffMenuItems;
//     }
//   }

//   const variant = isMobile ? 'temporary' : 'persistent';

//   return (
//     <Drawer
//       variant={variant}
//       open={isMobile ? isOpen : true}
//       onClose={toggleSidebar}
//       ModalProps={{ keepMounted: true }}
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//           top: theme.mixins.toolbar.minHeight,
//           height: `calc(100% - ${theme.mixins.toolbar.minHeight}px)`,
//           backgroundColor: GOLD,
//           color: '#000',
//           borderRight: 'none',
//         },
//       }}
//     >
//       <List sx={{ width: '100%' }}>
//         {menuItems.map((item) => {
//           const isActive = activePath === item.path;

//           return (
//             <ListItemButton
//               key={item.text}
//               onClick={() => {
//                 navigate(item.path);
//                 if (isMobile) toggleSidebar();
//               }}
//               sx={{
//                 borderRadius: 0,

//                 // 🔥 Increase height so hover borders fit and don't overlap black line
//                 minHeight: 58,

//                 px: 2,
//                 py: 1.2,
//                 position: "relative",

//                 bgcolor: isActive ? "#000" : GOLD_DARK,
//                 color: isActive ? GOLD_BORDER : "#000",

//                 // ONLY one black line at bottom
//                 borderBottom: "2px solid #000",

//                 // PREVENT MOVEMENT: reserve border area
//                 borderTop: "2px solid transparent",
//                 borderRight: "2px solid transparent",

//                 // HOVER EFFECT
//                 "&:hover": {
//                   bgcolor: "#000",
//                   color: GOLD_BORDER,
//                   borderTop: `2px solid ${GOLD_BORDER}`,
//                   borderRight: `2px solid ${GOLD_BORDER}`,
//                   borderBottom: `2px solid ${GOLD_BORDER}`,
//                 },
//               }}
//             >
//               {/* ICON + square on hover */}
//               <ListItemIcon
//                 sx={{
//                   minWidth: 36,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",

//                   "& .icon-box": {
//                     width: 30,
//                     height: 30,
//                     border: `2px solid ${
//                       isActive ? GOLD_BORDER : "transparent"
//                     }`,
//                     display: "flex",
//                     alignItems: "center",
//                     justifyContent: "center",
//                   },

//                   color: isActive ? GOLD_BORDER : "#000",

//                   // Hover → gold icon box + gold icon
//                   ".MuiListItemButton-root:hover & .icon-box": {
//                     borderColor: GOLD_BORDER,
//                   },
//                   ".MuiListItemButton-root:hover & svg": {
//                     color: GOLD_BORDER,
//                   },
//                 }}
//               >
//                 <div className="icon-box">{item.icon}</div>
//               </ListItemIcon>

//               {/* TEXT */}
//               <ListItemText
//                 primary={item.text}
//                 primaryTypographyProps={{
//                   fontWeight: "bold",
//                   color: isActive ? GOLD_BORDER : "#000",
//                   sx: {
//                     ".MuiListItemButton-root:hover &": {
//                       color: GOLD_BORDER,
//                     },
//                   },
//                 }}
//               />
//             </ListItemButton>
//           );
//         })}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;




















// import React, { useState, useEffect } from 'react';
// import {
//   Drawer,
//   List,
//   ListItemButton,
//   ListItemIcon,
//   ListItemText,
//   useTheme,
//   useMediaQuery,
// } from '@mui/material';

// import {
//   Inventory as InventoryIcon,
//   People as PeopleIcon,
//   Receipt as ReceiptIcon,
//   AttachMoney as PaymentIcon,
//   Assignment as TaskIcon,
//   Home as HomeIcon,
//   CloudUpload as CloudUploadIcon,
//   Settings as SettingsIcon,
//   LocalShipping as SupplierIcon,
// } from '@mui/icons-material';

// import { useNavigate } from 'react-router-dom';
// import API_BASE_URL from '../../config/api';

// const Sidebar = ({
//   isOpen = true,
//   toggleSidebar = () => {},
//   drawerWidth = 200,
// }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
//   const navigate = useNavigate();

//   const activePath = window.location.pathname;

//   // 🎨 New theme colors
//   const GOLD = '#C4A574';
//   const GOLD_LIGHT = '#D9B67E';
//   const DARK_BG = '#3d3d3d';
//   const DARKER_BG = '#2a2a2a';

//   const userRole = localStorage.getItem('role');
//   const [staffType, setStaffType] = useState(null);

//   // 🔒 OLD: Fetch staff type (unchanged)
//   useEffect(() => {
//     const fetchStaffType = async () => {
//       if (userRole === 'Staff') {
//         try {
//           const token = localStorage.getItem('token');
//           const response = await fetch(
//             `${API_BASE_URL}/api/staff/my-salary-with-type`,
//             {
//               headers: { Authorization: `Bearer ${token}` },
//             }
//           );

//           if (response.ok) {
//             const data = await response.json();
//             setStaffType(data.staffType);
//           }
//         } catch (error) {
//           console.error('Error fetching staff type:', error);
//         }
//       }
//     };

//     fetchStaffType();
//   }, [userRole]);

//   // 🔒 OLD menus (unchanged)
//   const adminMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Staff', icon: <PeopleIcon />, path: '/staff' },
//     { text: 'Boutique Schedule', icon: <TaskIcon />, path: '/boutique-schedule' },
//     { text: 'Tasks', icon: <TaskIcon />, path: '/admin/tasks' },
//     { text: 'Customers', icon: <PeopleIcon />, path: '/admin/customers' },
//     { text: 'Suppliers', icon: <SupplierIcon />, path: '/admin/suppliers' },
//     { text: 'Other Expenses', icon: <PaymentIcon />, path: '/expenses' },
//     { text: 'Import Data', icon: <CloudUploadIcon />, path: '/admin/import' },
//     { text: 'Export Data', icon: <SettingsIcon />, path: '/admin/export' },
//   ];

//   const hourlyStaffMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Attendance & Salary', icon: <PaymentIcon />, path: '/my-attendance-salary' },
//   ];

//   const taskBasedStaffMenuItems = [
//     { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
//     { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
//     { text: 'Salary', icon: <PaymentIcon />, path: '/my-salary' },
//     { text: 'My Tasks', icon: <TaskIcon />, path: '/my-tasks' },
//   ];

//   let menuItems = adminMenuItems;
//   if (userRole === 'Staff') {
//     if (staffType === 'Hourly') menuItems = hourlyStaffMenuItems;
//     if (staffType === 'Task-Based') menuItems = taskBasedStaffMenuItems;
//   }

//   const variant = isMobile ? 'temporary' : 'persistent';

//   return (
//     <Drawer
//       variant={variant}
//       open={isMobile ? isOpen : true}
//       onClose={toggleSidebar}
//       ModalProps={{ keepMounted: true }}
//       sx={{
//         width: drawerWidth,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//           width: drawerWidth,
//           boxSizing: 'border-box',
//           backgroundColor: DARK_BG,
//           color: '#fff',
//           borderRight: '1px solid rgba(196, 165, 116, 0.2)',
//           top: 80,
//           height: 'calc(100% - 80px)',
//         },
//       }}
//     >
//       <List sx={{ p: 0 }}>
//         {menuItems.map((item) => {
//           const isActive = activePath === item.path;

//           return (
//             <ListItemButton
//               key={item.text}
//               onClick={() => {
//                 navigate(item.path);
//                 if (isMobile) toggleSidebar();
//               }}
//               sx={{
//                 minHeight: 56,
//                 px: 2.5,
//                 py: 1.5,
//                 bgcolor: isActive ? DARKER_BG : 'transparent',
//                 color: isActive ? GOLD : '#999',
//                 borderLeft: isActive
//                   ? `4px solid ${GOLD}`
//                   : '4px solid transparent',
//                 transition: 'all 0.25s ease',
//                 '&:hover': {
//                   bgcolor: DARKER_BG,
//                   color: GOLD_LIGHT,
//                   borderLeftColor: GOLD_LIGHT,
//                 },
//               }}
//             >
//               <ListItemIcon
//                 sx={{
//                   minWidth: 40,
//                   color: 'inherit',
//                 }}
//               >
//                 {item.icon}
//               </ListItemIcon>

//               <ListItemText
//                 primary={item.text}
//                 primaryTypographyProps={{
//                   fontWeight: isActive ? 700 : 500,
//                   fontSize: '0.95rem',
//                 }}
//               />
//             </ListItemButton>
//           );
//         })}
//       </List>
//     </Drawer>
//   );
// };

// export default Sidebar;








// ...existing code...
import React, { useState, useEffect } from 'react';
import {
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  useTheme,
  useMediaQuery,
} from '@mui/material';

import {
  Inventory as InventoryIcon,
  People as PeopleIcon,
  Receipt as ReceiptIcon,
  AttachMoney as PaymentIcon,
  Assignment as TaskIcon,
  Home as HomeIcon,
  CloudUpload as CloudUploadIcon,
  Settings as SettingsIcon,
  LocalShipping as SupplierIcon,
  Store as StoreIcon,
} from '@mui/icons-material';

import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';

const Sidebar = ({ isOpen = undefined, toggleSidebar = () => {}, drawerWidth = 200 }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const navigate = useNavigate();

  const activePath = window.location.pathname;

  // 🎨 New theme colors
  const GOLD = '#C4A574';
  const GOLD_LIGHT = '#D9B67E';
  const DARK_BG = '#3d3d3d';
  const DARKER_BG = '#2a2a2a';

  const [staffType, setStaffType] = useState(() => localStorage.getItem('staffType'));
  const [staffTypeLoaded, setStaffTypeLoaded] = useState(
    localStorage.getItem('role') !== 'Staff' || !!localStorage.getItem('staffType')
  );

  useEffect(() => {
    const fetchStaffType = async () => {
      const userRole = localStorage.getItem('role');
      if (userRole === 'Staff') {
        try {
          const token = localStorage.getItem('token');
          const response = await fetch(`${API_BASE_URL}/api/staff/my-salary-with-type`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          if (response.ok) {
            const data = await response.json();
            setStaffType(data.staffType);
            localStorage.setItem('staffType', data.staffType);
          }
        } catch (error) {
          console.error('Error fetching staff type:', error);
        } finally {
          setStaffTypeLoaded(true);
        }
      }
    };

    fetchStaffType();
  }, []);

  const adminMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
    { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
    { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
    { text: 'Staff', icon: <PeopleIcon />, path: '/staff' },
    { text: 'Schedule', icon: <TaskIcon />, path: '/boutique-schedule' },
    { text: 'Tasks', icon: <TaskIcon />, path: '/admin/tasks' },
    { text: 'Customers', icon: <PeopleIcon />, path: '/admin/customers' },
    { text: 'Suppliers', icon: <SupplierIcon />, path: '/admin/suppliers' },
    { text: 'Other Expenses', icon: <PaymentIcon />, path: '/expenses' },
    { text: 'Import Data', icon: <CloudUploadIcon />, path: '/admin/import' },
    { text: 'Export Data', icon: <SettingsIcon />, path: '/admin/export' },
  ];

  const hourlyStaffMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
    { text: 'Bill Creation', icon: <ReceiptIcon />, path: '/bills' },
    { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
    { text: 'Attendance & Salary', icon: <PaymentIcon />, path: '/my-attendance-salary' },
  ];

  const taskBasedStaffMenuItems = [
    { text: 'Home', icon: <HomeIcon />, path: '/dashboard' },
    { text: 'Inventory', icon: <InventoryIcon />, path: '/inventory' },
    { text: 'Salary', icon: <PaymentIcon />, path: '/my-salary' },
    { text: 'My Tasks', icon: <TaskIcon />, path: '/my-tasks' },
  ];

  let menuItems = adminMenuItems;
  const userRole = localStorage.getItem('role');
  if (userRole === 'Staff') {
    if (!staffTypeLoaded) menuItems = []; // don't flash admin menu while loading
    else if (staffType === 'Hourly') menuItems = hourlyStaffMenuItems;
    else if (staffType === 'Task-Based') menuItems = taskBasedStaffMenuItems;
  }

  // local mobile open state + global event fallback so hamburger works even if parent doesn't control state
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onToggle = () => setMobileOpen((s) => !s);
    window.addEventListener('toggleSidebar', onToggle);
    return () => window.removeEventListener('toggleSidebar', onToggle);
  }, []);

  // compute Drawer open state:
  // - on desktop always open (persistent)
  // - on mobile: prefer isOpen prop if boolean, otherwise use internal mobileOpen
  const drawerOpen = isMobile ? (typeof isOpen === 'boolean' ? isOpen : mobileOpen) : true;

  const handleCloseMobile = () => {
    setMobileOpen(false);
    if (typeof toggleSidebar === 'function') toggleSidebar();
  };

  const variant = isMobile ? 'temporary' : 'persistent';

  return (
    <Drawer
      variant={variant}
      open={drawerOpen}
      onClose={() => {
        if (isMobile) handleCloseMobile();
      }}
      ModalProps={{ keepMounted: true }}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: isMobile ? '100%' : drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: DARK_BG,
          color: '#fff',
          borderRight: '1px solid rgba(196, 165, 116, 0.2)',
          ...(isMobile
            ? { top: 80, height: 'calc(100% - 80px)' }
            : { top: 80, height: 'calc(100% - 80px)' }),
        },
      }}
    >
      <List sx={{ width: '100%', p: 0 }}>
        {menuItems.map((item) => {
          const isActive = activePath === item.path;

          return (
            <ListItemButton
              key={item.text}
              onClick={() => {
                navigate(item.path);
                if (isMobile) handleCloseMobile();
              }}
              sx={{
                minHeight: 56,
                px: 2.5,
                py: 1.5,
                bgcolor: isActive ? DARKER_BG : 'transparent',
                color: isActive ? GOLD : '#999',
                borderLeft: isActive ? `4px solid ${GOLD}` : '4px solid transparent',
                transition: 'all 0.25s ease',
                '&:hover': {
                  bgcolor: DARKER_BG,
                  color: GOLD_LIGHT,
                  borderLeftColor: GOLD_LIGHT,
                },
              }}
            >
              <ListItemIcon sx={{ minWidth: 40, color: 'inherit' }}>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} primaryTypographyProps={{ fontWeight: isActive ? 700 : 500, fontSize: '0.95rem' }} />
            </ListItemButton>
          );
        })}
      </List>
    </Drawer>
  );
};

export default Sidebar;
// ...existing code...
